import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Shield } from 'lucide-react';
import api from '../utils/api';

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/audit').then(res => setLogs(res.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex items-center justify-center h-96"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div></div>;

  return (
    <div className="space-y-6" data-testid="audit-logs-page">
      <div><h1 className="text-4xl font-bold text-gray-900">Audit Logs</h1><p className="text-gray-600">GMP Compliance - Track all system activities</p></div>
      <Card><CardHeader><CardTitle className="flex items-center"><Shield className="w-5 h-5 mr-2" />Audit Trail</CardTitle></CardHeader><CardContent><div className="space-y-2">{logs.map((log, idx) => (<div key={idx} className="p-3 border-l-4 border-blue-500 bg-gray-50 rounded" data-testid={`log-${idx}`}><div className="flex justify-between items-start"><div><p className="text-sm font-medium">{log.user_email} <span className="text-gray-600">{log.action}</span> {log.entity_type}</p><p className="text-xs text-gray-500 mt-1">Entity ID: {log.entity_id}</p></div><span className="text-xs text-gray-500">{new Date(log.timestamp).toLocaleString()}</span></div></div>))}{logs.length === 0 && <p className="text-center py-12 text-gray-500">No audit logs found</p>}</div></CardContent></Card>
    </div>
  );
}
